import Area, { IArea } from "../../core/areas/Area";
import Application from "../../Application";
import { IRouter } from "../../runtime/Router";
import LoginPage from "../ui/pages/LoginPage";
import ShowLoginInteractor from "../interactor/ShowLoginInteractor";
import LogoutPage from "../ui/pages/LogoutPage";
import LogoutInteractor from "../interactor/LogoutInteractor";
import LoginInteractor from "../interactor/LoginInteractor";
import LoadUserPreferencesInteractor from "../interactor/LoadUserPreferencesInteractor";
import CheckLoginStatusInteractor from "../interactor/CheckLoginStatusInteractor";
import { Layouts } from "../../core/common/Constants";
import ShowChangePasswordInteractor from "../interactor/ShowChangePasswordInteractor";
import ChangePasswordInteractor from "../interactor/ChangePasswordInteractor";
import PasswordChangePage from "../ui/pages/PasswordChangePage";

export default class AuthenticationArea extends Area implements IArea {
  private application: Application;
  private router: IRouter;

  constructor({
    application,
    router
  }: {
    application: Application;
    router: IRouter;
  }) {
    super();
    this.application = application;
    this.router = router;
  }
  private registerModules() {
    const container = this.application.container;

    container.registerInteractor("showLogin", ShowLoginInteractor);
    container.registerInteractor("login", LoginInteractor);
    container.registerInteractor("logout", LogoutInteractor);
    container.registerInteractor(
      "checkLoginStatus",
      CheckLoginStatusInteractor
    );
    container.registerInteractor(
      "loadUserPreferences",
      LoadUserPreferencesInteractor
    );
    container.registerInteractor(
      "showChangePassword",
      ShowChangePasswordInteractor
    );
    container.registerInteractor("changePassword", ChangePasswordInteractor);
  }
  register(params: any) {
    this.registerModules();
    this.router.registerRoutes(
      {
        path: "/login",
        page: this.createPage({
          Page: LoginPage,
          action: this.showLoginPage.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.BASE
        }
      },
      {
        path: "/dologout",
        page: this.createPage({
          Page: LogoutPage,
          action: this.logout.bind(this)
        }),
        options: {
          secure: false,
          layout: Layouts.BASE
        }
      },
      {
        path: "/change-password",
        page: this.createPage({
          Page: PasswordChangePage,
          action: this.showChangePassword.bind(this)
        }),
        options: {
          secure: true,
          layout: Layouts.BASE
        }
      },
      {
        path: "/set-password",
        page: this.createPage({
          Page: PasswordChangePage,
          action: this.showSetPassword.bind(this)
        }),
        options: {
          layout: Layouts.BASE
        }
      }
    );
  }
  public showChangePassword({
    username,
    oldPassword,
    setPassword
  }: {
    username: string;
    oldPassword: string;
    setPassword?: boolean;
  }) {
    return this.application.container
      .resolve<ShowChangePasswordInteractor>("showChangePassword")
      .execute(username, oldPassword, setPassword);
  }
  public showSetPassword({
    username,
    oldPassword
  }: {
    username: string;
    oldPassword: string;
  }) {
    return this.application.container
      .resolve<ShowChangePasswordInteractor>("showChangePassword")
      .execute(username, oldPassword, true);
  }
  public showLoginPage({
    username,
    redirect
  }: {
    username?: string;
    redirect?: string;
  }) {
    return this.application.container
      .resolve<ShowLoginInteractor>("showLogin")
      .execute(username, redirect);
  }

  public logout() {
    return this.application.container
      .resolve<LogoutInteractor>("logout")
      .execute();
  }
}
